import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

const columnsWithActions = (columns, { onDownloadActionClick }) => {
  const renderCell = (params) => {
    return (
      <>
        <GridActionsCellItem
          icon={<ArrowDownwardIcon />}
          onClick={() => onDownloadActionClick(params)}
          label="download"
        />
      </>
    );
  };

  return [
    ...columns,
    {
      headerName: "Download Email",
      field: "actions",
      type: "actions",
      width: 150,
      renderCell,
    },
  ];
};

const SearchDataGrid = ({
  columns,
  DataGridProps,
  sortModel,
  pageSize,
  page,
  onPaginationChange,
  onSortChange,
  searchResult,
  onDownloadActionClick,
  customFooter,
}) => {
  const gridColumns = columnsWithActions(columns, {
    onDownloadActionClick,
  });

  let customComponents = {};

  if (!!customFooter) {
    customComponents.Footer = () => customFooter(searchResult);
  }
  const currentPage = searchResult.totalCount === 0 && page !== 0 ? 0 : page;

  return (
    <>
      <DataGrid
        columns={gridColumns}
        columnBuffer={gridColumns.length + 1}
        rowHeight={32}
        columnHeaderHeight={36}
        components={customComponents}
        localeText={{
          noRowsLabel: searchResult.error ?? "No rows",
        }}
        sx={{
          "& .MuiDataGrid-iconSeparator": {
            display: "none",
          },
          "& .MuiCheckbox-root svg": {
            width: 15,
            height: 15,
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: 0,
          },
          border: "none",
        }}
        sortingOrder={["desc", "asc"]}
        sortModel={sortModel}
        paginationModel={{ pageSize, page: currentPage }}
        disableRowSelectionOnClick
        disableColumnSelector
        disableColumnFilter
        disableColumnMenu
        onPaginationModelChange={onPaginationChange}
        sortingMode="server"
        onSortModelChange={onSortChange}
        paginationMode="server"
        pageSizeOptions={[25, 50, 100]}
        {...DataGridProps}
        rows={searchResult.result}
        rowCount={searchResult.totalCount}
      />
    </>
  );
};

export { SearchDataGrid };
